import React from 'react';
import { Box, TextField, CircularProgress } from '@mui/material';
import { ReactComponent as SendArrowIcon } from '../../assets/send-arrow.svg';

const ChatInputBar: React.FC<{ value: string; onChange: (v: string) => void; onSend: () => void; isLoading?: boolean }> = ({ value, onChange, onSend, isLoading = false }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', px: '16px', py: '16px', backgroundColor: 'transparent' }}>
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', backgroundColor: '#FFFFFF', borderRadius: '50px', boxShadow: '0px 4px 4px rgba(0,0,0,0.25)', border: '1px solid #E2E2E2', height: '60px', pl: '24px', pr: '6px', gap: 2 }}>
            <TextField
                fullWidth variant="standard"
                placeholder="Ask anything about your data..."
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && !isLoading && onSend()}
                InputProps={{ disableUnderline: true }}
                sx={{ '& input': { fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '14px', fontWeight: 500, color: '#1E293B', '&::placeholder': { color: '#94A3B8', opacity: 1 } } }}
            />
            <Box component="button" onClick={onSend} disabled={isLoading}
                sx={{ backgroundColor: '#003771', color: '#fff', width: '48px', height: '48px', borderRadius: '50%', border: 'none', flexShrink: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 0, outline: 'none', transition: 'background-color 0.2s', '&:hover': { backgroundColor: '#002B59' }, '&:disabled': { backgroundColor: '#7A9BB8', cursor: 'not-allowed' } }}
            >
                {isLoading ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : <SendArrowIcon width={22} height={20} />}
            </Box>
        </Box>
    </Box>
);

export default ChatInputBar;
